export const select = {
  sex: {
    title: 'Kelamin',
    value: {
      male: 'Lelaki',
      female: 'Perempuan'
    }
  },
  select_or_type: 'Pilih atau Masuk',
  required_trunk: 'Pilih sumber data'
};
